import React from 'react';

import { laptopQuery, desktopQuery } from '../utils/mediaqueries';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const Icon = ({ iconName, size, color, className, marginTop, marginLeft, marginRight, marginBottom }) => (
  <FontAwesomeIcon
    className={className}
    size={size}
    icon={iconName}
    color={color}
    css={{
      marginTop: marginTop,
      marginLeft: marginLeft,
      marginRight: marginRight,
      marginBottom: marginBottom,

      [laptopQuery]: {
        size: '8x',
      },
      [desktopQuery]: {
        size: '8x',
      },
    }}
  />
);

export default Icon;
